import React from "react"
import { Helmet } from "react-helmet"
import { graphql } from "gatsby"

import Navbar from "../components/navbar/navbar"
import Footer from "../components/footer/footer"
import Container from "../components/container/container"

export default function Page({ data }) {
    const post = data.markdownRemark

    return (
        <React.Fragment>
          <Helmet>
            <title>Engineering: people's work | Witteveen+Bos</title>
          </Helmet>
          <Navbar />
          <Container>
            <h1>{post.frontmatter.title}</h1>
            <div dangerouslySetInnerHTML={{ __html: post.html }} />
          </Container>
          <Footer />
        </React.Fragment>
    )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(
      frontmatter: { slug: { eq: $slug } }
    ) {
      html
      frontmatter {
        title
        subtitle
      }
    }
  }
`